// Art collection category names used across the application
// These match the categories shown in the Art Collection UI
export const FALLBACK_CATEGORY_NAMES = [
  'Best Sellers',
  'Sayings',
  'Abstract',
  'Beach',
  'Plants',
  'Flowers',
  'Mountains',
  'Animals',
  'Kids',
  'Classic Art',
  'Urban',
  'Lines',
  'Botanical',
] as const

// Map old category names to new category names for redirects
export const REDIRECT_CATEGORY: Record<string, string> = {
  Plants: 'Botanical',
  Flowers: 'Botanical',
  Animals: 'Nature',
  Mountains: 'Nature',
  Urban: 'Travel',
  Lines: 'Abstract',
}
